import { useEffect, useMemo } from 'react';
import { Site, useSiteContext } from 'utils/contexts/SiteContext';
import { useLocalStorage } from 'utils/hooks/useStorage';

export type SimpleSite = Pick<Site, 'name' | 'site_id'>;

const STORE_MAXIMUM = 5;

export const useRecentSites = () => {
    const { site } = useSiteContext();
    const [recentSites, setRecentSites] = useLocalStorage<SimpleSite[]>(
        'recentSites',
        []
    );

    // filter out selected site
    const recentSitesFiltered = useMemo(() => {
        return recentSites.filter(({ site_id }) => site_id !== site?.site_id);
    }, [recentSites, site]);

    useEffect(() => {
        if (!site) {
            return;
        }

        setRecentSites((previousSites) => {
            const recentIndex = previousSites.findIndex(
                ({ site_id }) => site.site_id === site_id
            );

            // already at top, no need to do anything
            if (recentIndex === 0) {
                return previousSites;
            }

            const updatedSites = [...previousSites];
            // not in list, add to top
            if (recentIndex < 0) {
                return [site, ...updatedSites.slice(0, STORE_MAXIMUM)];
            }

            // in list but at different spot, move to top
            updatedSites.splice(recentIndex, 1);
            return [site, ...updatedSites];
        });
    }, [setRecentSites, site]);

    return recentSitesFiltered;
};
